// Mock data for TDM DRAGON promet d.o.o.

export const companyInfo = {
  name: "TDM DRAGON promet d.o.o.",
  tagline: "Vaš partner za profesionalne usluge",
  description: "Vodećа kompanija za pružanje visokokvalitetnih usluga u ugostiteljstvu, organizaciji događaja, smještaju i logistici.",
  phone: "+385 99 870 7646",
  email: "info@tdm-dragon.eu",
  address: "Svetice 6, 10000 Zagreb, Hrvatska"
};

export const services = [
  {
    id: 1,
    title: "Ugostiteljstvo",
    description: "Profesionalne ugostiteljske usluge za sve vrste događaja i proslava.",
    icon: "UtensilsCrossed",
    image: "https://images.unsplash.com/photo-1759419039105-68b8b12660f7",
    features: [
      "Elegantni restorani",
      "Catering usluge",
      "Prilagođeni jelovnici",
      "Profesionalno osoblje"
    ]
  },
  {
    id: 2,
    title: "Oprema za Catering",
    description: "Sva potrebna oprema za pružanje vrhunskih catering usluga.",
    icon: "ChefHat",
    image: "https://images.unsplash.com/photo-1758648207539-b40dd1f6b50e",
    features: [
      "Moderna oprema",
      "Najam opreme",
      "Tehničка podrška",
      "Dostava i postavljanje"
    ]
  },
  {
    id: 3,
    title: "Organizacija Događaja",
    description: "Kompleksna organizacija manifestacija na otvorenom i zatvorenom.",
    icon: "CalendarCheck",
    image: "https://images.unsplash.com/photo-1675171155224-e70a5eeb27c3",
    features: [
      "Planiranje događaja",
      "Tehnička podrška",
      "Dekoracija prostora",
      "Koordinacija izvođača"
    ]
  },
  {
    id: 4,
    title: "Koncerti i Priredbe",
    description: "Profesionalna organizacija koncerata i kulturnih priredbi.",
    icon: "Music",
    image: "https://images.unsplash.com/photo-1563841930606-67e2bce48b78",
    features: [
      "Postava pozornice",
      "Svjetlosna oprema",
      "Zvučni sustav",
      "Sigurnost događaja"
    ]
  },
  {
    id: 5,
    title: "Smještaj za Uzvanike",
    description: "Komforan i profesionalan smještaj za vaše uzvanike.",
    icon: "Hotel",
    image: "https://images.unsplash.com/photo-1618773928121-c32242e63f39",
    features: [
      "Moderne sobe",
      "Visok standard",
      "Usluge recepcije 24/7",
      "Dodatne pogodnosti"
    ]
  },
  {
    id: 6,
    title: "Smještaj za Radnike",
    description: "Organiziran i siguran smještaj za radnike na projektima.",
    icon: "Users",
    image: "https://images.unsplash.com/photo-1709805619372-40de3f158e83",
    features: [
      "Kapaciteti za grupe",
      "Čist i siguran prostor",
      "Svi potrebni sadržaji",
      "Fleksibilni aranžmani"
    ]
  },
  {
    id: 7,
    title: "Logistika",
    description: "Sveobuhvatne logističke usluge i transport.",
    icon: "Truck",
    image: "https://images.unsplash.com/photo-1634638022229-5a52221886dc",
    features: [
      "Transportne usluge",
      "Skladištenje",
      "Distribucija",
      "Praćenje pošiljki"
    ]
  },
  {
    id: 8,
    title: "Promet Nekretninama",
    description: "Profesionalne usluge u prometu poslovnih i stambenih nekretnina.",
    icon: "Building2",
    image: "https://images.pexels.com/photos/17797763/pexels-photo-17797763.jpeg",
    features: [
      "Prodaja nekretnina",
      "Najam prostora",
      "Procjena vrijednosti",
      "Pravna podrška"
    ]
  },
  {
    id: 9,
    title: "Prodaja Građevinskog Materijala",
    description: "Širok asortiman kvalitetnog građevinskog materijala za sve vaše projekte.",
    icon: "Blocks",
    image: "https://images.unsplash.com/photo-1637241612956-b7309005288b",
    features: [
      "Građevinski materijali",
      "Alati i oprema",
      "Dostava na gradilište",
      "Stručno savjetovanje"
    ]
  }
];

export const galleryImages = [
  {
    id: 1,
    url: "https://images.unsplash.com/photo-1758518726869-01aff69a56e3",
    title: "Poslovni sastanak",
    category: "Koncerti"
  },
  {
    id: 2,
    url: "https://images.unsplash.com/photo-1583795484071-3c453e3a7c71",
    title: "Svjetlosna produkcija",
    category: "Događaji"
  },
  {
    id: 3,
    url: "https://images.unsplash.com/photo-1595576508898-0ad5c879a061",
    title: "Hotelska soba",
    category: "Smještaj"
  },
  {
    id: 4,
    url: "https://images.pexels.com/photos/11951876/pexels-photo-11951876.jpeg",
    title: "Poslovna zgrada",
    category: "Nekretnine"
  },
  {
    id: 5,
    url: "https://images.unsplash.com/photo-1758518729912-bf3a84c400e0",
    title: "Timski rad",
    category: "Događaji"
  },
  {
    id: 6,
    url: "https://images.unsplash.com/photo-1609924480239-ed5cf2b4b672",
    title: "Moderna arhitektura",
    category: "Nekretnine"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Marko Horvat",
    company: "Event Solutions d.o.o.",
    text: "TDM DRAGON je organizirao naš godišnji koncert bez ikakvih problema. Profesionalnost na najvišoj razini!",
    rating: 5
  },
  {
    id: 2,
    name: "Ana Kovačević",
    company: "Hotel Grand",
    text: "Catering usluge su bile izvanredne. Svi gosti su bili oduševljeni kvalitetom hrane i usluge.",
    rating: 5
  },
  {
    id: 3,
    name: "Petar Novak",
    company: "Construction Pro",
    text: "Smještaj za naše radnike je bio odličan. Sve potrebno na jednom mjestu, preporučujemo!",
    rating: 5
  }
];

export const stats = [
  {
    id: 1,
    number: "500+",
    label: "Realiziranih Projekata"
  },
  {
    id: 2,
    number: "15+",
    label: "Godina Iskustva"
  },
  {
    id: 3,
    number: "1000+",
    label: "Zadovoljnih Klijenata"
  },
  {
    id: 4,
    number: "50+",
    label: "Stručnih Djelatnika"
  }
];

// Mock function for contact form submission
export const submitContactForm = async (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("Contact form submitted:", formData);
      resolve({ success: true, message: "Poruka uspješno poslana!" });
    }, 1000);
  });
};